import script from "./EditableTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./EditableTitle.vue?vue&type=script&setup=true&lang=js"

import "./EditableTitle.vue?vue&type=style&index=0&id=254e12ca&lang=scss&scoped=true"

import exportComponent from "/home/deployer/deploypad/silogues/releases/20261022152544/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-254e12ca"]])

export default __exports__